
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-if-let.json") })
        }
      }, "path---tags-if-let");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---tags-if-let!./.cache/json/tags-if-let.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---tags-if-let!./.cache/json/tags-if-let.json
// module chunks = 45